var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysFilters = function SvgSysFilters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.551 13.688H1.595a.5.5 0 0 1 0-1h1.956a2.159 2.159 0 0 1 4.2 0h6.845a.5.5 0 1 1 0 1H7.75a2.159 2.159 0 0 1-4.2 0Zm.938-.5a1.16 1.16 0 1 0 .001-.003l-.001.002Zm5.09-4.512H1.595a.5.5 0 0 1 0-1h7.983a2.16 2.16 0 0 1 4.2 0h.814a.5.5 0 0 1 0 1h-.815a2.16 2.16 0 0 1-4.2 0h.002Zm2.1.664a1.163 1.163 0 1 0-1.163-1.225.51.51 0 0 1 0 .117 1.166 1.166 0 0 0 1.167 1.106l-.004.002ZM1.09 3.238a2.158 2.158 0 0 1 1.885-2.14A2.159 2.159 0 0 1 5.34 2.693h9.253a.5.5 0 0 1 0 1H5.36a2.163 2.163 0 0 1-2.34 1.692 2.163 2.163 0 0 1-1.93-2.149v.002Zm1 0a1.165 1.165 0 0 0 .714 1.074 1.16 1.16 0 1 0 .446-2.23 1.161 1.161 0 0 0-1.153 1.152l-.007.004Z"
  })));
};
export default SvgSysFilters;